if ( typeof PaVariantGallery !== 'function' ) {

	class PaVariantGallery extends HTMLElement {

		connectedCallback(){

			if ( this._paInit ) return;
			this._paInit = true;

			this.wrapper = document.getElementById(this.dataset.paVgWrapper);
			if ( ! this.wrapper ) return;

			this.gallery = this.wrapper.querySelector('[data-js-product-gallery]');
			this.variants = this.wrapper.querySelector('product-variants[data-main-product-variants]');
			if ( ! this.gallery ) return;

			try {
				this.owners = JSON.parse(this.querySelector('[data-pa-vg-owners]').textContent);
			} catch(err) {
				return;
			}

			// estado inicial: replica o <style> server-side em classes e corrige os índices do slider
			this.applyFilter(this.readCurrentVariant(), true);
			const initialStyle = this.querySelector('[data-pa-vg-initial-style]');
			if ( initialStyle ) initialStyle.remove();

			if ( this.variants ) {
				this.variants.addEventListener('VARIANT_CHANGE', e=>{
					this.applyFilter(e.target.currentVariant || this.readCurrentVariant());
				});
			}

			const slider = this.getSlider();
			if ( slider ) {
				slider.addEventListener('change', ()=>{
					// o realce ativo do tema é posicional (thumbnailNavigationHelper);
					// corrigir num timeout para correr depois do handler do tema
					setTimeout(()=>this.syncActiveThumbnail(), 0);
				});
				slider.addEventListener('ready', ()=>{
					// modo 'scroll' (watchCSS) destrói/recria o slider em resize e o
					// destroySlider restaura o HTML original sem as classes — reaplicar
					// (defensivo; em produção a galeria usa sempre o modo slider)
					const variant = this.readCurrentVariant();
					this.applyFilter(variant, true);
					// o nosso listener 'ready' regista-se antes do do tema (script incluído
					// antes do content_for_layout) — atualizar aqui o índice que o handler de
					// parallax do tema vai consumir a seguir evita o changeSlide com o
					// data-index desatualizado de antes do resetSlider (era isto que rebentava
					// em deep links, ver ProductPage.firstProductGalleryIndex)
					if ( variant && variant.featured_media ) {
						const targetSlide = this.gallery.querySelector(`.product-gallery-item[data-media-id="${variant.featured_media.id}"]`);
						if ( targetSlide ) this.wrapper.firstProductGalleryIndex = targetSlide.dataset.index;
					}
				});
			}

		}

		getSlider(){
			return this.gallery.querySelector('css-slider');
		}

		readCurrentVariant(){
			const data = this.wrapper.querySelector('[data-js-variant-data]');
			if ( data ) {
				try { return JSON.parse(data.textContent); } catch(err) {}
			}
			return null;
		}

		applyFilter(variant, initial=false){

			// dono a mostrar: featured_media da variante; null = mostrar tudo (fallback)
			const ownerToShow = variant && variant.featured_media ? String(variant.featured_media.id) : null;
			let targetSlide = null;

			this.gallery.querySelectorAll('.product-gallery-item[data-media-id]').forEach(slide=>{
				const owner = this.owners[slide.dataset.mediaId] || 'global';
				const hide = ownerToShow !== null && owner != 'global' && owner != ownerToShow;
				slide.classList.toggle('pa-vg-hidden', hide);
				if ( ownerToShow !== null && slide.dataset.mediaId == ownerToShow ) {
					targetSlide = slide;
				}
			});

			this.gallery.querySelectorAll('.thumbnail[data-media-id]').forEach(thumb=>{
				const owner = this.owners[thumb.dataset.mediaId] || 'global';
				thumb.classList.toggle('pa-vg-hidden', ownerToShow !== null && owner != 'global' && owner != ownerToShow);
			});

			this.refreshSlider();
			this.syncThumbnailIndexes();
			this.normalizeHiddenIndexes();

			// navegação autoritativa p/ o início do bloco: o handler do tema corre antes
			// ou depois deste conforme a superfície (PDP vs quick view); este salto 'auto'
			// dá o estado final correto em qualquer ordem
			const slider = this.getSlider();
			if ( ! initial && targetSlide && slider && slider.sliderEnabled ) {
				slider.changeSlide(targetSlide.dataset.index, 'auto');
			}

		}

		refreshSlider(){

			const slider = this.getSlider();
			if ( ! slider || ! slider.sliderEnabled ) return;

			// resetSlider() só limpa os marcadores dos elementos em slider.items — limpar
			// aqui todos evita css-slide--snap órfão em slides escondidos; e slides
			// display:none medem largura 0, o que partiria o cálculo de slidesPerPage
			slider.querySelectorAll('.product-gallery-item').forEach(slide=>{
				slide.classList.remove('css-slide--snap');
			});
			slider.items = slider.querySelectorAll('.product-gallery-item:not(.pa-vg-hidden)');
			slider.resetSlider(true);

			const thumbsBar = this.gallery.querySelector('.product-gallery__thumbnails');
			if ( thumbsBar ) {
				const visible = thumbsBar.querySelectorAll('.thumbnail:not(.pa-vg-hidden)');
				thumbsBar.classList.toggle('pa-vg-hidden', visible.length <= 1);
			}

		}

		syncThumbnailIndexes(){
			this.gallery.querySelectorAll('.thumbnail[data-media-id]').forEach(thumb=>{
				const slide = this.gallery.querySelector(`.product-gallery-item[data-media-id="${thumb.dataset.mediaId}"]`);
				if ( slide && slide.hasAttribute('data-index') ) {
					thumb.dataset.index = slide.dataset.index;
				}
			});
		}

		normalizeHiddenIndexes(){

			// defesa p/ superfícies onde o handler do tema (VARIANT_CHANGE / 'ready' do slider)
			// corre antes do nosso refiltro (ex.: quick view, onde a ordem de upgrade dos
			// custom elements não segue a mesma posição relativa do documento principal) —
			// se isso acontecer, ele navega com o data-index desatualizado dum slide que
			// estava escondido; aproximamos esse índice do início do bloco a que pertence
			// para o slider não rebentar (o nosso applyFilter corrige a posição exata a seguir)
			const dividerFutureIndex = {};
			let globalsSeen = 0;

			this.gallery.querySelectorAll('.product-gallery-item[data-media-id]').forEach(slide=>{
				const owner = this.owners[slide.dataset.mediaId] || 'global';
				if ( owner != 'global' && slide.dataset.mediaId == owner ) {
					// divisor do bloco: futuro índice = nº de globais que o precedem no DOM
					// (o conjunto visível de qualquer variante = globais + o bloco dela)
					dividerFutureIndex[owner] = globalsSeen;
				}
				if ( owner == 'global' ) globalsSeen++;
			});

			this.gallery.querySelectorAll('.product-gallery-item.pa-vg-hidden[data-media-id]').forEach(slide=>{
				const owner = this.owners[slide.dataset.mediaId] || 'global';
				if ( dividerFutureIndex[owner] !== undefined ) {
					slide.dataset.index = String(dividerFutureIndex[owner]);
				}
			});

		}

		syncActiveThumbnail(){
			const slider = this.getSlider();
			if ( ! slider ) return;
			const thumbs = this.gallery.querySelectorAll('.thumbnail');
			if ( ! thumbs.length ) return;
			thumbs.forEach(t=>t.classList.remove('active'));
			const active = this.gallery.querySelector(`.thumbnail:not(.pa-vg-hidden)[data-index="${slider.index}"]`);
			if ( active ) active.classList.add('active');
		}

	}

	if ( typeof customElements.get('pa-variant-gallery') == 'undefined' ) {
		customElements.define('pa-variant-gallery', PaVariantGallery);
	}

}
